//- SCRIPTS DO ESPECIAL

$(function () {
    var $general = $('#general-especial'),
        reach = 0;

    var carousel = function() {
        $('.carousel', $general).each(function() {
            var $carousel = $(this),
                $wrapper = $('.wrapper', $carousel),
                options = {
                    items: 1,
                    lazyLoad: true,
                    loop: true,
                    navContainer: $wrapper,
                    nav: true,
                    dots: false
                };

            $($wrapper).owlCarousel(options);
        })
    }

    var storyboard = function() {
        var $storyboard = $('.storyboard', $general);

        var mySwiper = new Swiper ('.storyboard', {
            direction: 'vertical',
            loop: false,
            lidesPerView: 1,
            coverflowEffect: {
                rotate: 30,
                slideShadows: false,
            },
            mousewheel: {
                releaseOnEdges: true,
            },
            iOSEdgeSwipeDetection: true,
            touchReleaseOnEdges: true,
            on: {
                slideChange: function() {
                    $('html, body').stop().animate({
                        scrollTop: $storyboard.offset().top
                    }, 400);
                },
            }
        })
    }

    carousel();
    storyboard();
});

